@import (reference) '../../../../constants/spacing.module.less';

.rate-amount {
  color: var(--light--text-color--1);
}

.cost-review-container {
  padding: @space-0;
}

// TODO: Remove this in SPD-14646
.cost-review-button {
  color: var(--primary--link--text-color--5);
  &:hover {
    color: var(--primary--link--text-color--5) !important;
    text-decoration: underline !important;
  }
}

.refresh-rate-button {
  height: 30px;
}

.refresh-rate-button-icon {
  color: var(--default--icon--fill-color--13);
  width: 16px;
  height: 16px;
  margin: @space-0;
  padding: @space-0;
}

.rate-container {
  align-items: center;
  gap: @space-8;
}

.third-party-billing-tooltip-icon {
  transform: none;
  height: 16px;
  width: 16px;
}

.third-party-billing-tooltip-icon-container {
  height: 16px;
}

.rate-and-cost-review-container {
  flex: 1;
  justify-content: center;
}
